import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Modal } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages, PREFIX } from "../../../i18n/i18n";
import { style as howToModalStyle } from "./HowToModal.style";

interface HowToModalProps {
  readonly visible: boolean;
  readonly portalHostName?: string;
  readonly onDismiss: () => void;
}

const HowToModal: FC<HowToModalProps> = ({ visible, portalHostName, onDismiss }) => {
  const titleText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HOW_TO_TITLE, prefix: PREFIX });
  const descriptionText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HOW_TO_PARAGRAPH_1, prefix: PREFIX });
  const otherDescriptionText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HOW_TO_PARAGRAPH_2, prefix: PREFIX });

  const style = useMemo(() => howToModalStyle(), []);

  return (
    <Modal portalHostName={portalHostName} visible={visible} showCloseButton onClose={onDismiss}>
      <View style={style.modal}>
        <Text level={3} variant="heading">
          {titleText}
        </Text>

        <View style={style.modalGap}>
          <Text style={[style.text, style.descriptionText]}>{descriptionText}</Text>

          <Text style={style.text}>{otherDescriptionText}</Text>
        </View>
      </View>
    </Modal>
  );
};
export { HowToModal };
